import { Component } from '@angular/core';
import { BaseWidgetSettingsComponent } from '../../widget/base/base-widget';
import { IAdjustPanelWidgetConfig } from '../adjust-panel.component';
import { DxButtonModule, DxFormModule, DxPopupModule } from 'devextreme-angular';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { WidgetDataService } from '../../widget/data/widget-data.service';
import { MachineInfoMainService } from '../../../../../shared/services/machine-info.service';
import { MachineInfo } from '../../../../../../api/generated';
import { RemoteDataWrapperService } from '../../../../../shared/services/remote-data/remote-data-wrapper.service';
import { FieldDataChangedEvent } from 'devextreme/ui/form';

@Component({
  selector: 'app-adjust-panel-settings',
  standalone: true,
  imports: [DxFormModule, DxButtonModule, DxPopupModule],
  templateUrl: './adjust-panel-settings.component.html',
  styleUrl: './adjust-panel-settings.component.scss'
})
export class AdjustPanelSettingsComponent extends BaseWidgetSettingsComponent<IAdjustPanelWidgetConfig> {
  public machineOptions: {name: string;}[] = [];
  public sectionOptions: {index: number; name: string;}[] = [];

  private _unsubscriber: Subject<any> = new Subject<any>();
  private _sectionsSubscription?: Subscription;

  constructor(
    widgetDataService: WidgetDataService<IAdjustPanelWidgetConfig>,
    private readonly _miSvc: MachineInfoMainService,
    private readonly _remoteDataWrapper: RemoteDataWrapperService,
  ) {
    super(widgetDataService);

    this.formData = {
      title: 'Adjust Panel',
      machineName: undefined,
      sectionIndex: null,
    }
  }

  ngOnInit(): void {
    // Get lidt of machines for select box
    this._miSvc.dataSource.load().then((data) => {
      this.machineOptions = data.map((r: MachineInfo) => {
        return { name: r.Name };
      });
    });

    // Update form data if options change
    // this.widgetDataService.options$.pipe(takeUntil(this._unsubscriber)).subscribe((value) => {
    //   this.formData = value;

    //   if (this.formData?.machineName) {
    //     this.initSections(this.formData.machineName);
    //   }
    // });
  }

  ngOnDestroy(): void {
    this._unsubscriber.next(null);
    this._unsubscriber.complete();
  }

  /**
   * Make reaction of some important fileds in form.
   *
   * @param {FieldDataChangedEvent} event
   * @memberof AdjustPanelSettingsComponent
   */
  public onFormChanged(event: FieldDataChangedEvent): void {
    if (event.dataField === 'machineName') {
      this.formData!.sectionIndex = null;
      this.sectionOptions = [];
      this.initSections(event.value);
    }
  }

  public override setFormData(data: IAdjustPanelWidgetConfig): void {
    if (data.machineName) {
      this.initSections(data.machineName);
    }
    super.setFormData(data);
  }

  protected override onSubmitModal(): void {
    if (this.formData) {
      this.formData.title = `Adjust panel - ${this.sectionOptions.find(i => i.index === this.formData!.sectionIndex)?.name ?? ''}`;
      this.formData.subtitle = this.formData.machineName;
    }

    super.onSubmitModal();
  }

  private initSections(machineName: string): void {
    this._sectionsSubscription?.unsubscribe();
      this._sectionsSubscription = this._remoteDataWrapper.getMachineStructureRaw(machineName).subscribe((machineStructureRaw) => {
        if (machineStructureRaw && machineStructureRaw !== '{}') {
          try {
            console.log(machineStructureRaw);
            let dataObj = JSON.parse(machineStructureRaw);
            this.sectionOptions = [];
            dataObj.MachineOne.Sections._V.map((section: Partial<{_L: string}>, index: number) => {
              this.sectionOptions.push({ index, name: section._L ?? '' });
            });
          } catch (e) {
            console.error('Error parsing machine structure raw data', e);
          }
        }
      });
  }
}
